<template>
  <div class="more_button" :class="show ? 'active' : ''" @click="toggleModal()"></div>
  <div class="more_contents" v-if="show && type === 'review'" v-click-outside="closeModal">
    <review-edit :review="review" :shop-name="shopName" :image-url="imagePath" @update-event="updateEvent"></review-edit>
    <div class="delete" @click.stop="deleteReview()">
      <button type="button">投稿を削除</button>
    </div>
  </div>
  <div class="more_contents delete_only" v-if="show && type === 'community'" v-click-outside="closeModal">
    <div class="delete" @click.stop="deleteCommunity()">
      <button type="button">投稿を削除</button>
    </div>
  </div>

  <div v-show="completeFlag" class="form modal complete_modal" v-click-outside="closeCompleteModal">
    <div class="box">
      <div class="contents">
        <div class="complete">
          <div class="icon"></div>
          <h3>{{ message }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vClickOutside from 'click-outside-vue3'

export default {
  props: {
    type: {
      type: String,
      required: true
    },
    review: {
      type: Object,
      required: false
    },
    community: {
      type: Object,
      required: false
    },
    shopName: {
      type: String,
      required: false
    },
    imagePath: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      params: {
        id: null, // review.id OR community.id
      },
      show: false,
      completeFlag: false,
      message: '削除しました'
    }
  },
  mounted() {},
  methods: {
    closeModal() {
      this.show = false
    },
    closeCompleteModal() {
      if (this.completeFlag) {
        location.reload()
      }
    },
    toggleModal() {
      if (this.show) {
        this.show = false
      } else {
        this.show = true
      }
    },
    updateEvent() {
      this.message = 'レビュー更新を受け付けました'
      this.completeFlag = true

      setTimeout(function () {
        location.reload()
      }, 2000)
    },
    deleteReview() {
      this.params.id = this.review.id
      // レビュー削除API
      axios.post('/api/users/review/delete', this.params).then(res => {
        if (res.data.success) {
          this.message = 'レビューを削除しました'
          this.completeFlag = true

          setTimeout(function () {
            location.reload()
          }, 2000)

        } else {
          console.log(res.data.errors)
          this.errors = res.data.errors
        }
      }).catch(e => {
        console.log('Error', e)
      })
    },
    deleteCommunity() {
      this.params.id = this.community.id
      // コミュニティ削除API
      axios.post('/api/users/community/delete', this.params).then(res => {
        if (res.data.success) {
          this.message = 'コミュニティ投稿を削除しました'
          this.completeFlag = true

          setTimeout(function () {
            location.reload()
          }, 2000)

        } else {
          console.log(res.data.errors)
          this.errors = res.data.errors
        }
      }).catch(e => {
        console.log('Error', e)
      })
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  watch: {
    show(val) {
      if (!val) return
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../resources/sass/common.scss';

.complete_modal {
  .box {
    @include sp {
      position: initial !important;
    }

    .complete {
      > h3 {
        display: block;
        border: none;
      }
    }
  }
}
</style>
